// import React, { useState, useEffect } from "react";

// import {
//   Box,
//   Typography,
//   TextField,
//   Grid,
//   Button,
//   FormControl,
//   Select,
//   InputLabel,
//   MenuItem,
//   FormHelperText,
//   IconButton,
// } from "@mui/material";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";

// import {
//   createPurchase,
//   deletePurchase,
//   getallpurchaseOrders,
//   getPurchases,
//   updatePurchase,
// } from "../../api/purchase";
// import { getProjectList } from "../../api/project";
// import { getVendorList } from "../../api/vendor";
// import { handleAxiosError } from "../../config/action-config";

// import { purchaseTable as tableDef } from "../../config/grid-columns-defs";
// import ControlledTable from "../../component/ControlledTable";
// import DeleteAlertDialog from "../../component/DeleteAlertDialog";
// import UpdateDialog from "../../component/UpdateDialog";
// import CreateDialog from "../../component/CreateDialog";
// import { showAlert } from "../../actions/alert";
// import { capitalizeFirstLetter } from "../../config/grid-value-formatters";
// import { useForm, Controller } from "react-hook-form";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import { AgGridReact } from "ag-grid-react";

// const emptyUpdateData = {
//   po_description: "",
//   shipping_address: "",
//   po_amount: 0,
//   project_id: "",
//   vendor_id: "",
//   po_date: "",
//   delivery_date: "",
//   payment_terms: "",
// };
// const emptyNewPurchaseData = {
//   po_description: "",
//   shipping_address: "",
//   po_amount: "",
//   project_id: "",
//   vendor_id: "",
//   po_date: "",
//   delivery_date: "",
//   payment_terms: "",
// };
// function addAdditionalColumn(obj, dispatch) {
//   if (obj === undefined) {
//     tableDef.unshift({
//       headerName: "Action",
//       field: "actions",
//       resizable: true,
//       wrapText: true,
//       autoHeight: true,
//       minWidth: 65,
//       maxWidth: 65,
//       headerClass: "justify-center",
//       cellClass: "justify-center",
//       cellRendererFramework: (params) => (
//         <IconButton
//           color="info"
//           onClick={() => {
//             dispatch({ type: "VIEW", data: params.data });
//           }}
//           className="p-0"
//         >
//           <VisibilityIcon
//             fontSize="inherit"
//             size="10px"
//             className="p-0 crm-react-icon"
//           />
//         </IconButton>
//       ),
//     });
//   }
// }
// export default function Purchase() {
//   const {
//     register,
//     handleSubmit,
//     control,
//     reset,
//     formState: { errors },
//   } = useForm();
//   const user = useSelector((state) => state.user);
//   const dialogAction = useSelector((state) => state.dialog);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const [totalCount, setTotalCount] = useState(0);

//   const [rows, setRows] = useState([]);
//   const [pageNumber, setPageNumber] = useState(0);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [updateDialogOpen, setUpdateDialogeOpen] = useState(false);
//   const [createDialogOpen, setCreateDialogOpen] = useState(false);
//   const [deleteId, setDeleteId] = useState(-1);
//   const [updateId, setUpdateId] = useState(-1);

//   const [updateData, setUpdateData] = useState(emptyUpdateData);
//   const [newPurchaseData, setNewProjectData] = useState(emptyNewPurchaseData);
//   const [minDate, setMinDate] = useState("");
//   let obj = tableDef.find((o) => o.headerName === "Action");
//   addAdditionalColumn(obj, dispatch);
//   const onNewPurchaseSubmit = (newPurchaseData) => {
//     newPurchaseData.delivery_date =
//       newPurchaseData.delivery_date === ""
//         ? ""
//         : createDateAsUTC(newPurchaseData.delivery_date);
//     newPurchaseData.po_date =
//       newPurchaseData.po_date === ""
//         ? ""
//         : createDateAsUTC(newPurchaseData.po_date);

//     createPurchase({ ...newPurchaseData, po_amount: 0 }, user.token)
//       .then((res) => {
//         setCreateDialogOpen(false);
//         setNewProjectData(emptyNewPurchaseData);
//         dispatch(showAlert(res.data.msg));
//         refreshTable();
//       })
//       .catch((err) => {
//         handleAxiosError(err, dispatch);
//         setCreateDialogOpen(false);
//       });
//   };

//   const refreshTable = async() => {
//    await getallpurchaseOrders(
//       { limit: 1, offset: 0, sort: "creation_date desc" },
//       user.token
//     )
//       .then((res) => {
//         setTotalCount(
//           parseInt(res.data.totalPO)
//         );
//         setRows(res.data.POOrderlist);
//       })
//       .catch((err) => {
//         handleAxiosError(err, dispatch);
//       });
//   };

//   useEffect(() => {
//     if (!dialogAction.type) return;
//     switch (dialogAction.type) {
//       case "EDIT": {
//         setUpdateDialogeOpen(true);
//         const up = getUpdatableData(dialogAction.data);
//         setUpdateData(up);
//         break;
//       }
//       case "DELETE":
//         setDeleteDialogOpen(true);
//         break;
//       case "VIEW":
//         dispatch({ type: "" });
//         navigate(`${dialogAction.data.id}`);
//         break;
//       default:
//         break;
//     }
//   }, [dialogAction]);

//   useEffect(() => {
//     if (deleteId === -1) return;
//     deletePurchase(deleteId, user.token)
//       .then((res) => {
//         dispatch(showAlert(res.data.msg));
//         setDeleteId(-1);
//         refreshTable();
//         setDeleteDialogOpen(false);
//       })
//       .catch((err) => {
//         handleAxiosError(err, dispatch);
//         setDeleteId(-1);
//         setDeleteDialogOpen(false);
//       });
//   }, [deleteId]);

//   useEffect(() => {
//     if (updateId === -1) return;
//     updatePurchase(updateId, updateData, user.token)
//       .then((res) => {
//         dispatch(showAlert(res.data.msg));
//         setUpdateId(-1);
//         setUpdateData(emptyUpdateData);
//         refreshTable();
//         setUpdateDialogeOpen(false);
//       })
//       .catch((err) => {
//         handleAxiosError(err, dispatch);
//         setUpdateId(-1);
//         setUpdateDialogeOpen(false);
//       });
//   }, [updateId]);

//   const getRows = async (numRows, startRow) => {
//     return getallpurchaseOrders(
//       { limit: numRows, offset: startRow, sort: "creation_date desc" },
//       user.token
//     )
//       .then((res) => {
//         setTotalCount(parseInt(res.data.TotalPO));
//         return res.data.POOrderlist;
//       })
//       .catch((err) => {
//         handleAxiosError(err, dispatch);
//       });
//   };

//   // for dropdowns
//   const [projectList, setProjectList] = useState([]);
//   const [vendorList, setVendorList] = useState([]);
//   useEffect(() => {
//     refreshTable();
//     getProjectList(user.token).then((res) => {
//       setProjectList(res.data.data);
//     });
//     getVendorList(user.token).then((res) => {
//       setVendorList(res.data.data);
//     });
//   }, []);

//   const changeUpdateData = (e) => {
//     setUpdateData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };
//   const changeNewPurchaseData = (e) => {
//     setNewProjectData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };
//   useEffect(() => {
//     if (!createDialogOpen) {
//       setNewProjectData(emptyNewPurchaseData);
//     }
//   }, [createDialogOpen]);

//   return (
//     <Box className="pmt-container-box">
//       <Box className="pmt-title-box">
//         <Box className="typography-title">
//           <Typography variant="h1" className="pmt-headings-h1">
//             Purchase Order
//           </Typography>
//         </Box>
//         <Button
//           variant="contained"
//           style={{ padding: "5px 7px" }}
//           onClick={() => {
//             setCreateDialogOpen(true);
//           }}
//           className="blue-button"
//         >
//           Add Purchase Order
//         </Button>
//       </Box>
//       <br />
//       {/* <div className="pmt-controll-table">
//         <ControlledTable
//           rows={rows}
//           columnDefs={tableDef}
//           getRows={getRows}
//           totalCount={totalCount}
//           onChange={setRows}
//           onPageNumberChange={setPageNumber}
//           pageSize={10}
//           pageNumber={pageNumber}
//           pagination={true}
//           getRowNodeId={({ data }) => data?.id || data?.name}
//           hasActionButtons={false}
//         />
//       </div> */}
//         <div className="ag-theme-material pmt-controll-table">
//                   <AgGridReact
//                     columnDefs={tableDef}
//                     rowData={rows}
//                     rowSelection="single"
//                     // onRowClicked={(params) => {
//                     //   setSelectedItemRow(params.data.id);
//                     // }}
//                     domLayout="autoHeight"
//                     headerHeight="38"
//                     rowHeight={38}
//                     defaultColDef={{
//                       resizable: true,
//                       flex: 1,
//                     }}
//                   />
//                 </div>
//       <DeleteAlertDialog
//         open={deleteDialogOpen}
//         setOpen={setDeleteDialogOpen}
//         setDeleteId={setDeleteId}
//         rowId={dialogAction.data?.id}
//       />
//       <UpdateDialog
//         open={updateDialogOpen}
//         setOpen={setUpdateDialogeOpen}
//         setUpdateId={setUpdateId}
//         rowId={dialogAction.data?.id}
//       >
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={6} md={6}>
//             <TextField
//               margin="dense"
//               name="project_id"
//               fullWidth
//               value={updateData.project_id}
//               onChange={changeUpdateData}
//               label="Project Id"
//               type="number"
//               variant="outlined"
//             />
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <TextField
//               margin="dense"
//               name="vendor_id"
//               fullWidth
//               value={updateData.vendor_id}
//               onChange={changeUpdateData}
//               label="Vendor Id"
//               type="number"
//               variant="outlined"
//             />
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <TextField
//               margin="dense"
//               name="po_amount"
//               fullWidth
//               value={updateData.po_amount}
//               onChange={changeUpdateData}
//               label="Order Amount"
//               type="number"
//               variant="outlined"
//             />
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <TextField
//               margin="dense"
//               name="payment_terms"
//               fullWidth
//               value={updateData.payment_terms}
//               onChange={changeUpdateData}
//               label="Payment Terms"
//               type="text"
//               variant="outlined"
//             />
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <TextField
//               margin="dense"
//               name="shipping_address"
//               fullWidth
//               value={updateData.shipping_address}
//               onChange={changeUpdateData}
//               label="Shipping Address"
//               type="text"
//               variant="outlined"
//             />
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <TextField
//               margin="dense"
//               name="po_description"
//               fullWidth
//               value={updateData.po_description}
//               onChange={changeUpdateData}
//               label="Order Description"
//               type="text"
//               variant="outlined"
//             />
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <LocalizationProvider dateAdapter={AdapterDateFns}>
//               <DatePicker
//                 label="Order Date"
//                 value={updateData.po_date}
//                 onChange={(newValue) => {
//                   changeUpdateData({
//                     target: { name: "po_date", value: newValue },
//                   });
//                 }}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     helperText={params?.inputProps?.placeholder}
//                   />
//                 )}
//               />
//             </LocalizationProvider>
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <LocalizationProvider dateAdapter={AdapterDateFns}>
//               <DatePicker
//                 label="Delivery Date"
//                 value={updateData.delivery_date}
//                 onChange={(newValue) => {
//                   changeUpdateData({
//                     target: { name: "delivery_date", value: newValue },
//                   });
//                 }}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     helperText={params?.inputProps?.placeholder}
//                   />
//                 )}
//               />
//             </LocalizationProvider>
//           </Grid>
//         </Grid>
//       </UpdateDialog>
//       <CreateDialog
//         open={createDialogOpen}
//         setOpen={setCreateDialogOpen}
//         onSubmit={handleSubmit(onNewPurchaseSubmit)}
//       >
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={6} md={6}>
//             <FormControl
//               margin="dense"
//               fullWidth
//               required
//               error={Boolean(errors.project_id)}
//             >
//               <InputLabel id="demo-simple-select-label">Project</InputLabel>

//               <Controller
//                 render={(props) => (
//                   <Select value={props.value} onChange={props.onChange}>
//                     {projectList.map((p, i) => (
//                       <MenuItem key={i} value={p.id}>
//                         {capitalizeFirstLetter(p.project_name)}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 )}
//                 name="project_id"
//                 control={control}
//                 // defaultValue=""
//                 rules={{
//                   required: "Please select Project",
//                 }}
//               />
//               <FormHelperText>{errors.project_id?.message}</FormHelperText>
//             </FormControl>
//             {/* <FormControl fullWidth>
//               <InputLabel id="demo-simple-select-label-project">
//                 Project
//               </InputLabel>
//               <Select
//                 labelId="demo-simple-select-label-project"
//                 id="demo-simple-select-project"
//                 value={newPurchaseData.project_id}
//                 label="Project"
//                 name="project_id"
//                 onChange={changeNewPurchaseData}
//               >
//                 {projectList.map((p, i) => (
//                   <MenuItem key={i} value={p.id}>
//                     {capitalizeFirstLetter(p.project_name)}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl> */}
//             {/* <TextField margin="dense" name='project_id' fullWidth value={newPurchaseData.project_id}
//                             onChange={changeNewPurchaseData} label="Project Id" type="number" variant="outlined"
//                         /> */}
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <FormControl
//               margin="dense"
//               fullWidth
//               required
//               error={Boolean(errors.vendor_id)}
//             >
//               <InputLabel id="demo-simple-select-label">Vendor</InputLabel>

//               <Controller
//                 render={(props) => (
//                   <Select value={props.value} onChange={props.onChange}>
//                     {vendorList.map((v, i) => (
//                       <MenuItem key={i} value={v.id}>
//                         {capitalizeFirstLetter(v.vendor_name)}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 )}
//                 name="vendor_id"
//                 control={control}
//                 // defaultValue=""
//                 rules={{
//                   required: "Please select vendor",
//                 }}
//               />
//               <FormHelperText>{errors.vendor_id?.message}</FormHelperText>
//             </FormControl>
//             {/* <FormControl fullWidth>
//               <InputLabel id="demo-simple-select-label-vendor">
//                 Vendor
//               </InputLabel>
//               <Select
//                 labelId="demo-simple-select-label-vendor"
//                 id="demo-simple-select-vendor"
//                 value={newPurchaseData.vendor_id}
//                 label="Vendor"
//                 name="vendor_id"
//                 onChange={changeNewPurchaseData}
//               >
//                 {vendorList.map((v, i) => (
//                   <MenuItem key={i} value={v.id}>
//                     {capitalizeFirstLetter(v.vendor_name)}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl> */}
//             {/* <TextField margin="dense" name='vendor_id' fullWidth value={newPurchaseData.vendor_id}
//                             onChange={changeNewPurchaseData} label="Vendor Id" type="number" variant="outlined"
//                         /> */}
//           </Grid>
//           {/* <Grid item xs={12} sm={6} md={6}>
//             <TextField
//               margin="dense"
//               name="po_amount"
//               fullWidth
//               // value={newPurchaseData.po_amount}
//               // onChange={changeNewPurchaseData}
//               label="Order Amount"
//               type="number"
//               variant="outlined"
//               inputRef={register({
//                 required: "Order Amount is required.",
//               })}
//               error={Boolean(errors.po_amount)}
//               helperText={errors.po_amount?.message}
//             />
//           </Grid> */}
//           <Grid item xs={12} sm={6} md={6}>
//             <TextField
//               margin="dense"
//               name="payment_terms"
//               fullWidth
//               // value={newPurchaseData.payment_terms}
//               // onChange={changeNewPurchaseData}
//               label="Payment Terms"
//               type="text"
//               variant="outlined"
//               inputRef={register({
//                 required: "Payment Terms is required.",
//               })}
//               required
//               error={Boolean(errors.payment_terms)}
//               helperText={errors.payment_terms?.message}
//             />
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <TextField
//               margin="dense"
//               name="shipping_address"
//               fullWidth
//               // value={newPurchaseData.shipping_address}
//               // onChange={changeNewPurchaseData}
//               label="Shipping Address"
//               type="text"
//               variant="outlined"
//               inputRef={register({
//                 required: "Shipping Address is required.",
//               })}
//               required
//               error={Boolean(errors.shipping_address)}
//               helperText={errors.shipping_address?.message}
//             />
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <TextField
//               margin="dense"
//               name="po_description"
//               fullWidth
//               // value={newPurchaseData.po_description}
//               // onChange={changeNewPurchaseData}
//               label="Order Description"
//               type="text"
//               variant="outlined"
//               inputRef={register({
//                 required: "Order Description is required.",
//               })}
//               required
//               error={Boolean(errors.po_description)}
//               helperText={errors.po_description?.message}
//             />
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <FormControl required fullWidth error={Boolean(errors.po_date)}>
//               <LocalizationProvider dateAdapter={AdapterDateFns}>
//                 <Controller
//                   render={(props) => (
//                     <DatePicker
//                        inputFormat="MM/dd/yyyy"
//                       value={props.value || ""}
//                       label="Order Date"
//                       onChange={(nv) => {
//                         props.onChange(nv);
//                         setMinDate(nv);
//                       }}
//                       // onChange={props.onChange}
//                       renderInput={(params) => (
//                         <TextField
//                         required
//                           error={Boolean(errors.po_date)}
//                           {...params}
//                         />
//                       )}
//                     />
//                   )}
//                   rules={{
//                     required: "Order Date is required.",
//                   }}
//                   name="po_date"
//                   control={control}
//                 />
//               </LocalizationProvider>
//               <FormHelperText>{errors.po_date?.message}</FormHelperText>
//             </FormControl>
//             {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
//               <DatePicker
//                 label="Order Date"
//                 value={newPurchaseData.po_date}
//                 onChange={(newValue) => {
//                   changeNewPurchaseData({
//                     target: { name: "po_date", value: newValue },
//                   });
//                 }}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     helperText={params?.inputProps?.placeholder}
//                   />
//                 )}
//               />
//             </LocalizationProvider> */}
//           </Grid>
//           <Grid item xs={12} sm={6} md={6}>
//             <FormControl
//               required
//               fullWidth
              
//               error={Boolean(errors.delivery_date)}
//             >
//               <LocalizationProvider dateAdapter={AdapterDateFns}>
//                 <Controller
//                   render={(props) => (
//                     <DatePicker
//                        inputFormat="MM/dd/yyyy"
//                       value={props.value || ""}
//                       label="Delivery Date"
//                       shouldDisableDate={disablePrevDates(new Date(minDate))}
//                       onChange={props.onChange}
//                       renderInput={(params) => (
//                         <TextField
//                         required
//                           error={Boolean(errors.delivery_date)}
//                           {...params}
//                         />
//                       )}
//                     />
//                   )}
//                   rules={{
//                     required: "Delivery Date is required.",
//                   }}
//                   name="delivery_date"
//                   control={control}
//                 />
//               </LocalizationProvider>
//               <FormHelperText>{errors.delivery_date?.message}</FormHelperText>
//             </FormControl>
//             {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
//               <DatePicker
//                 label="Delivery Date"
//                 value={newPurchaseData.delivery_date}
//                 onChange={(newValue) => {
//                   changeNewPurchaseData({
//                     target: { name: "delivery_date", value: newValue },
//                   });
//                 }}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     helperText={params?.inputProps?.placeholder}
//                   />
//                 )}
//               />
//             </LocalizationProvider> */}
//           </Grid>
//         </Grid>
//       </CreateDialog>
//     </Box>
//   );
// }

// function getUpdatableData(data) {
//   return {
//     po_description: data.po_description,
//     shipping_address: data.shipping_address,
//     po_amount: data.po_amount,
//     project_id: data.project_id,
//     vendor_id: data.vendor_id,
//     po_date: data.po_date,
//     delivery_date: data.delivery_date,
//     payment_terms: data.payment_terms,
//   };
// }
// function disablePrevDates(startDate) {
//   const startSeconds = Date.parse(startDate);
//   return (date) => {
//     return Date.parse(date) < startSeconds;
//   };
// }
// function createDateAsUTC(date) {
//   return new Date(
//     Date.UTC(
//       date.getFullYear(),
//       date.getMonth(),
//       date.getDate(),
//       date.getHours(),
//       date.getMinutes(),
//       date.getSeconds()
//     )
//   );
// }


import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { deleteBillById, getAllBills } from "../../api/bill";
// import { useRouter } from "next/router";
// import Link from "next/link";
// import toast from "react-hot-toast";
import { getVendorList } from "../../api/vendor";
import AgTable from "../../component/Ag-Table/AgTable";
import { Link } from "react-router-dom";
import { Clear, Search } from "@mui/icons-material";

import {
  createPurchase,
  deletePurchase,
  getallpurchaseOrders,
  getPurchases,
  updatePurchase,
} from "../../api/purchase";
import {insertNewpurchaseOrder} from "../../api/purchase";
 import { purchaseTable as tableDef } from "../../config/grid-columns-defs";
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  Tabs,
  Tab,
  IconButton,
   Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  Button,
  TextField,
  InputLabel,
  MenuItem,
  Select
} from "@mui/material";
import TabPanel from "../../component/TabPanel";
 import { showAlert, showSuccess } from "../../actions/alert";
import { Delete } from "@mui/icons-material";
import { getLowestLevelTask, getProjectList } from "../../api/project";
import {useDispatch } from "react-redux";
import { getAllInventory } from "../../api/inVentory";
const expenseTypes = ["Labor", "Material", "Equipment"];
const initialExpense = {
 vendor_id : "", 
    project_id : "", 
    total_amount : "", 
    shipping_date : "",
    discount_terms :"" , 
    fob_instruction : "", 
};

 export default function Bills() {
  const dispatch =useDispatch(); 
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [vendorName, setVendorName] = useState("");
  const [billNumber, setBillNumber] = useState("");
  const [allVendorList, setAllVendorList] = useState([]);
  const user = useSelector((state) => state.user);
  const [filter, setFilter] = useState();
  const [deleteId, setDeleteId] = useState(false);
  // const router = useRouter();
  const [gridApi, setGridApi] = useState(null);
  const [BillNO, setBillNO] = useState("");
  const [Status, setStatus] = useState("");
  const [Pono, setPono] = useState("");
  const [rowData, setRowData] = useState([]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [expenses, setExpenses] = useState([]);
        const [vendorData, setVendorData] = useState([]);
        const [formData, setFormData] = useState(initialExpense);
        const [open, setOpen] = useState(false);
        const [editMode, setEditMode] = useState(false);
        const [projectId, setProjectId] = useState("");
        const [projects, setProjects] = useState([]);
        const [taskList, setTaskList] = useState([]);
        const [employeesList, setEmployeesList] = useState([]);
        const [taskDisabled, setTaskDisabled] = useState(true);
        const [invetoryArray, setInventoryArray] = useState([]);
          const [expandedRows, setExpandedRows] = useState({});
        
          const [subTableData, setSubTableData] = useState({});
          const [loadingRows, setLoadingRows] = useState({});
        const [lineItems, setLineItems] = useState([
          { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
        ]);
    
        const handleLineItemChange = (index, field, value) => {
        const updatedItems = [...lineItems];
        updatedItems[index][field] = value;
        if (field === "inventory_id") {
          const selectedInventory = invetoryArray.find(
            (item) => item.id.toString() === value.toString()
          );
          if (selectedInventory) {
            updatedItems[index].unit_price = selectedInventory.unit_price || "";
          } else {
            updatedItems[index].unit_price = "";
          }
        }
        // Recalculate total amount
        const totalAmount = updatedItems.reduce((sum, item) => {
          const price = parseFloat(item.unit_price) || 0;
          const qty = parseFloat(item.quantity) || 0;
          return sum + price * qty;
        }, 0);
    
        setLineItems(updatedItems);
        setFormData((prev) => ({
          ...prev,
          total_amount: totalAmount.toFixed(2),
        }));
      };
      const fetchAllInvetory = async () => {
        try {
          const { data } = await getAllInventory(user.token, {
            limit: "",
            offset: "",
            status: "stock_item",
            vendorname: "",
            manufacturer: "",
            category: "",
            internalSku: "",
            itemDescription: "",
            is_active: "t",
          });
          // setRefresh(false);
          // setMovethenRefresh(false);
          setInventoryArray([...data.data.Inventory]);
          return {
            rows: data.data.Inventory,
            total: parseInt(data.data.total),
            error: false,
          };
        } catch (error) {
          console.log(error?.message);
          // setMovethenRefresh(false);
          // setRefresh(false);
          return { error: true };
        }
      };
      const addLineItem = () => {
        setLineItems([
          ...lineItems,
          { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
        ]);
      };
    
      const removeLineItem = (index) => {
        const updatedItems = [...lineItems];
        updatedItems.splice(index, 1);
    
        const totalAmount = updatedItems.reduce((sum, item) => {
          const price = parseFloat(item.unit_price) || 0;
          const qty = parseFloat(item.quantity) || 0;
          return sum + price * qty;
        }, 0);
    
        setLineItems(updatedItems);
        setFormData((prev) => ({
          ...prev,
          amount: totalAmount.toFixed(2),
        }));
      };
    
       const handleClose = () => {
        setFormData(initialExpense);
        setLineItems([
          { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
        ]);
        setOpen(false);
      };
    
        useEffect(() => {
          if (!projectId) return;
          setTaskDisabled(true);
      
          const project = projects.find((p) => p.id.toString() === projectId.toString());
        
          if (!project) {
            // Project with the given project_id was not found
            // Handle the situation accordingly
            return;
          }
          // getPurchaseData();
          // getPurchaseData()
          const isPmForProject = project.project_role === "PM";
      
          getLowestLevelTask(projectId, user.token, !isPmForProject)
            .then((res) => {
              setTaskList(res.data.data);
              setTaskDisabled(false);
            })
            .catch((err) => console.error("Error fetching tasks:", err));
         
        }, [projectId]);
      const handleChange = (e) => {
        const { name, value } = e.target;
        let updated = { ...formData, [name]: value };
    
        // if (["hoursOrQty", "rate"].includes(name)) {
        //   const qty = name === "hoursOrQty" ? +value : +formData.hoursOrQty;
        //   const rate = name === "rate" ? +value : +formData.rate;
        //   updated.Amount = qty * rate;
        // }
    
        setFormData(updated);
      };
    
       const handleSave = async (event) => {
        event.preventDefault();
         try {
                const { data } = await insertNewpurchaseOrder(
                  { ...formData, po_line: lineItems },
                  user.token
                );
                if (data.status) {
                  // setSites(
                  //   sites.map((site) => (site.id === formData.id ? formData : site))
                  // )
                  // getPurchaseData();
                  setOpen(false)
                  dispatch(showAlert("Po Created Successfully"));
                   refreshTable();
                  // showSuccess("Po Created Successfully");
                }
              } catch (error) {
                console.error("Error updating site:", error);
              } finally {
                setLineItems([
                  { task_id: "", inventory_id: "", unit_price: "", quantity: "" },
                ]);
                setFormData(initialExpense);
              }
       }
       
         const handleEdit = (expense) => {
           setProjectId(expense?.project_id);
           setFormData(expense);
           setEditMode(true);
           setOpen(true);
         };
       
         const handleDelete = (id) => {
           setExpenses((prev) => prev.filter((exp) => exp.expenseId !== id));
         };
       
          useEffect(() => {
             projectList();
             vendorList();
           }, []);
           const projectList = () => {
             getProjectList(user.token)
               .then((res) => {
                 setProjects(res.data.data);
               })
               .catch((err) => console.error("Error fetching projects:", err));
           };
           const vendorList = () => {
            getVendorList(user.token).then((res) => {
                 setVendorData(res.data.data);
               }) .catch((err) => console.error("Error fetching projects:", err));
              }
    

  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
 
 useEffect(() => {
    if (rowData.length > 0) {
      filterDataByDateRange();
    }
  }, [rowData, fromDate, toDate]);

  const filterDataByDateRange = () => {
    let filtered = [...rowData];

    if (fromDate || toDate) {
      filtered = rowData.filter((item) => {
       
        const itemDate = item.bill_date || item.created_date || item.po_date;

        if (!itemDate) return true; 

        const itemDateObj = new Date(itemDate);
        const fromDateObj = fromDate ? new Date(fromDate) : null;
        const toDateObj = toDate ? new Date(toDate) : null;

        // Set time to start/end of day for proper comparison
        if (fromDateObj) fromDateObj.setHours(0, 0, 0, 0);
        if (toDateObj) toDateObj.setHours(23, 59, 59, 999);

        if (fromDateObj && toDateObj) {
          return itemDateObj >= fromDateObj && itemDateObj <= toDateObj;
        } else if (fromDateObj) {
          return itemDateObj >= fromDateObj;
        } else if (toDateObj) {
          return itemDateObj <= toDateObj;
        }

        return true;
      });
    }

    setFilteredRowData(filtered);
  };
  const fetchAllBillLists = async (limit, offset) => {
    try {
      const { data } = await getallpurchaseOrders(user.token, {
        limit: limit,
        offset: offset,
        // po_number: Pono,
        // status: Status,
        // bill_number: BillNO,
        // from_date: fromDate,
        // to_date: toDate,
      });

      if (data.status) {
        setDeleteId(false);
        return {
          rows: data.data.POOrderlist,
          total: parseInt(data.data.TotalPO),
          error: false,
        };
      }
    } catch (error) {
      setDeleteId(false);
      return { error: true };
    }
  };

  const onDelete = async (id) => {
    setDeleteId(true);
    try {
      const res = await deleteBillById(id, user.token);
      setDeleteId(false);
      // toast.success(res.data.msg);
      refreshTable();
    } catch (error) {
      setDeleteId(false);
      // toast.error(error.message);
    }
  };

  useEffect(() => {
    getAllVendorsData();
    fetchAllInvetory();
  }, [user.token]);

  const getAllVendorsData = async () => {
    try {
      const { data } = await getVendorList(user.token, {});
      setAllVendorList(data.data.Vendor);
    } catch (error) {
      // toast.error(error.message);
    }
  };

  useEffect(() => {
    refreshTable();
  }, [BillNO, Status, Pono,fromDate && toDate]);
  const reset = () => {
    setBillNO("");
    setStatus("");
    setPono("");
    setFromDate("");
    setToDate("");
  };

  // const onSubmit = async (event) => {
  //   // event.preventDefault();
  //   try {
  //     const res = await ThreeWayMatchData(user.token, event);
  //     if (res.data.status) {
  //       setModalIsOpen(true);
  //       setRowData(res.data.data);
  //       setBillNumber(event);
  //       // setResponseData(res.data.data.Result.matchedItems);
  //       // setUnmatchedPOItems(res.data.data.Result.unmatchedPOItems);
  //       // setUnmatchedBillItems(res.data.data.Result.unmatchedBillItems);
  //       // setPo("false")
  //     }
  //   } catch (error) {
  //     setModalIsOpen(false);
  //     // toast.error(error.message);
  //   }
  // };

  return (
    <>
    
           <Box className="pmt-title-box">
                <Box className="typography-title w-full flex justify-between">
                  <Typography variant="h1" className="pmt-headings-h1">
                     Purchase Order
                  </Typography>
                     <Button variant="contained" size="small" onClick={() => setOpen(true)}>Add Purchase</Button>
                </Box>
              
    

        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-2 bg-[#fff] rounded-[10px] p-3 mb-2">
          <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
            <label className="capitalize text-[#000] font-medium">
              Filter by Bill No.
            </label>
            <input
              type="text"
              value={BillNO || ""}
              onChange={(e) => setBillNO(e.target.value)}
              placeholder="Enter the Invoice Payment No."
              className="bg-[#fff] w-full bg-opacity-50 rounded border border-gray-300 focus:border-blue-500 focus:bg-transparent focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="col-span-1 sm:col-span-1 lg:col-span-1 grid gap-1">
            <label className="capitalize text-[#000] font-medium">
              Filter by Status
            </label>
            <input
              type="text"
              value={Status || ""}
              onChange={(e) => setStatus(e.target.value)}
              placeholder="Enter the Status"
              className="bg-[#fff] w-full bg-opacity-50 rounded border border-gray-300 focus:border-blue-500 focus:bg-transparent focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
            <label className="capitalize text-[#000] font-medium">
              Filter by PO Number
            </label>
            <input
              type="text"
              value={Pono || ""}
              onChange={(e) => setPono(e.target.value)}
              placeholder="Enter the PO Number"
              className="bg-[#fff] w-full bg-opacity-50 rounded border border-gray-300 focus:border-blue-500 focus:bg-transparent focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
            <label className="capitalize text-[#000] font-medium">
              Filter by Start Date
            </label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="bg-[#fff] w-full bg-opacity-50 rounded border border-gray-300 focus:border-blue-500 focus:bg-transparent focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1">
            <label className="capitalize text-[#000] font-medium">
              Filter by End Date
            </label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              min={fromDate}
              className="bg-[#fff] w-full bg-opacity-50 rounded border border-gray-300 focus:border-blue-500 focus:bg-transparent focus:ring-2 focus:ring-blue-200 text-base outline-none text-gray-700 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="col-span-1 sm:col-span-1 lg:col-span-1  flex justify-start items-end">
            {BillNO || Status || Pono||fromDate||toDate ? (
              <button
                onClick={() => reset()}
                className="bg-[#000000] items-center flex gap-1 mb-1 text-[#fff] rounded-[5px] px-[10px] py-[5px]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-[15px] h-[15px]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
                RESET
              </button>
            ) : null}
          </div>
          {/* <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1  flex-justify-center items-center">
            <label className="capitalize text-[#000] mb-2 font-medium"></label>
            <button
              type="button"
              onClick={() => router.push(`/bills/create-bill`)}
              className="bg-[#00308F] gap-2 h-[45px] text-[#fff] font-semibold capitalize p-[5px] text-md text-sm rounded-[5px] px-[20px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff] float-right"
            >
              Create Bill
            </button>
          </div> */}
        {/* </div> */} 
        </Box>
      
        {/* Filter and Table Section */}
        <div className="bg-white rounded-lg shadow-lg mt-[20px]">
          {/* Filters */}

          {/* Table */}
          <div className="col-span-2 mt-1 mb-4 ag-theme-material owb-table">
            <AgTable
              getTableRows={fetchAllBillLists}
              columns={[
                // {
                //   headerName: "Actions",
                //   field: "actions",
                //   minWidth: 120,
                //   cellRenderer: (params) => (
                //     <>
                //       <div className="flex w-full gap-3 justify-center">
                //         <button
                //           disabled={deleteId}
                //           onClick={() => onDelete(params?.data?.id)}
                //           // className="bg-[#3f63ea] py-1 text-[#fff] to-[#145df1] capitalize h-[30px] p-[5px] text-sm font-normal rounded-[5px] w-[80px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
                //           title="delete"
                //         >
                //           <img
                //             width="28"
                //             height="28"
                //             src="https://img.icons8.com/fluency-systems-filled/48/808080//trash.png"
                //             alt="filled-trash"
                //           />
                //         </button>
                //         {/* <button
                //           // disabled={deleteId}
                //           onClick={() => onSubmit(params?.data?.id)}
                //           // className="bg-[#3f63ea] py-1 text-[#fff] to-[#145df1] capitalize h-[30px] p-[5px] text-sm font-normal rounded-[5px] w-[80px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
                //           title="3 Way Match"
                //         >
                //           <img
                //             width="28"
                //             height="28"
                //             src="https://img.icons8.com/color/48/search--v1.png"
                //             alt="Match"
                //           />
                //         </button> */}
                //       </div>
                //     </>
                //   ),
                // },
                ...tableDef,
              ]}
              perPage={10}
              refresh={tableRefreshCount}
              setRefresh={""}
              classN={""}
              setGridData={""}
              gridOptions={""}
              setGridApi={setGridApi}
              gridApi={gridApi}
              components={""}
            />
          </div>
        </div>
       
         <Dialog open={open} className="" onClose={handleClose} fullWidth maxWidth="md">
                  <DialogTitle>{"Create Purchase Order"}</DialogTitle>
                  <form onSubmit={handleSave}>
                    <DialogContent>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth>
                            <InputLabel>Project</InputLabel>
                            <Select
                              name="project_id"
                              className="expense-modal"
                              required
                              value={formData.project_id}
                              onChange={(e) => {
                                handleChange(e);
                                setProjectId(e.target.value);
                              }}
                            >
                              <MenuItem value="">
                                <em>Select Project</em>
                              </MenuItem>
                              {projects.map((p, i) => (
                                <MenuItem key={i} value={p.id}>
                                  {p.project_name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
          
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth>
                            <InputLabel>Vendor</InputLabel>
                            <Select
                              required

                              name="vendor_id"
                              value={formData.vendor_id}
                              onChange={handleChange}
                            >
                              <MenuItem value="">
                                <em>Select Vendor</em>
                              </MenuItem>
                              {vendorData.map((site) => (
                                <MenuItem key={site.id} value={site.id}>
                                  {site.vendor_name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
    
                        <Grid item xs={12} sm={4}>
                          <h2 className="text-[#000] font-semibold flex items-center justify-end gap-2">Total Amount : {parseFloat(formData?.total_amount ||"0").toLocaleString("en-US", {
                       style: "currency",
                       currency: "USD",
                     })}</h2>
                            {/* <TextField
                              name="total_amount"
                               label="Total Amount"
                              value={formData.total_amount}
                              onChange={handleChange}
                              type="amount"
                               fullWidth
                            InputLabelProps={{ shrink: true }}
                            /> */}
                            
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="shipping_date"
                            label="Shipping Date"
                            type="date"
                            required
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={formData.shipping_date}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="discount_terms"
                            label="Discount Terms"
                            fullWidth
                            value={formData.discount_terms}
                            onChange={handleChange}
                            // InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="fob_instruction"
                            label="FOB Instruction"
                            fullWidth
                            value={formData.fob_instruction}
                            onChange={handleChange}
                          />
                        </Grid>
          
                        {/* ✅ Line Items Table */}
                         <div className="mt-6">
                           {/* Header with Add Button */}
                           <div className="flex justify-between items-center mb-4">
                           
                             <button
                               type="button"
                               className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded shadow transition"
                               onClick={addLineItem}
                             >
                               + Add Item
                             </button>
                           </div>
                       
                           {/* Table Container */}
                           <div className="border border-gray-300 rounded-lg overflow-hidden shadow-sm">
                             {/* Table Header */}
                             <div className="overflow-x-auto">
                               <table className="min-w-full text-sm text-left bg-gray-50">
                                 <thead className="bg-gray-100 sticky top-0 z-10">
                                   <tr>
                                     <th className="border px-4 py-3 font-semibold text-gray-700">Task</th>
                                     <th className="border px-4 py-3 font-semibold text-gray-700">Inventory</th>
                                     {/* <th className="border px-4 py-3 font-semibold text-gray-700">Type</th> */}
                                     <th className="border px-4 py-3 font-semibold text-gray-700">Unit Price ($)</th>
                                     <th className="border px-4 py-3 font-semibold text-gray-700">Quantity</th>
                                     <th className="border px-4 py-3 font-semibold text-center text-gray-700">
                                       Actions
                                     </th>
                                   </tr>
                                 </thead>
                       
                       
                             {/* Scrollable Body */}
                         
                                 <tbody  className="min-w-full text-sm text-left bg-white">
                                   {lineItems?.map((item, index) => (
                                     <tr key={index} className="hover:bg-gray-50 transition">
                                       {/* Task Select */}
                                       <td className="border px-3 py-2">
                                         <select
                                           className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                           value={item.task_id}
                                           required
                                           onChange={(e) =>
                                             handleLineItemChange(index, "task_id", e.target.value)
                                           }
                                         >
                                           <option value="">Select Task</option>
                                           {taskList.map((t) => (
                                             <option key={t.id} value={t.id}>
                                               {t.task_code} - {t.task_name}
                                             </option>
                                           ))}
                                         </select>
                                       </td>
                       
                                       {/* Inventory Select */}
                                       <td className="border px-3 py-2">
                                         <select
                                           className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                           value={item.inventory_id}
                                           required
                                           onChange={(e) =>
                                             handleLineItemChange(index, "inventory_id", e.target.value)
                                           }
                                         >
                                           <option value="">Select Inventory</option>
                                           {invetoryArray.map((inv) => (
                                             <option key={inv.id} value={inv.id}>
                                               {inv.inventory_name}
                                             </option>
                                           ))}
                                         </select>
                                       </td>
                       
                                       {/* Expense Type */}
                                       {/* <td className="border px-3 py-2">
                                         <select
                                           className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                           value={item.expense_type}
                                           required
                                           onChange={(e) =>
                                             handleLineItemChange(index, "expense_type", e.target.value)
                                           }
                                         >
                                           <option value="">Select Type</option>
                                           {expenseTypes.map((type) => (
                                             <option key={type} value={type}>
                                               {type}
                                             </option>
                                           ))}
                                         </select>
                                       </td> */}
                       
                                       {/* Unit Price */}
                                       <td className="border px-3 py-2">
                                         <input
                                           type="number"
                                           className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                           value={item.unit_price}
                                           onChange={(e) =>
                                             handleLineItemChange(index, "unit_price", e.target.value)
                                           }
                                         />
                                       </td>
                       
                                       {/* Quantity */}
                                       <td className="border px-3 py-2">
                                         <input
                                           type="number"
                                           className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                           value={item.quantity}
                                           onChange={(e) =>
                                             handleLineItemChange(index, "quantity", e.target.value)
                                           }
                                         />
                                       </td>
                       
                                       {/* Remove Button */}
                                       <td className="border px-3 py-2 text-center">
                                         <IconButton
                                           onClick={() => removeLineItem(index)}
                                           className="text-red-600 hover:text-red-800 transition"
                                           title="Remove item"
                                         >
                                           <Delete />
                                         </IconButton>
                                       </td>
                                     </tr>
                                   ))}
                                 </tbody>
                            
                               </table>
                             </div>
                           </div>
                         </div>
                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Button type="button" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button variant="contained" type="submit">
                        {"Save"}
                      </Button>
                    </DialogActions>
                  </form>
                </Dialog>
    </>
  );
}

export const convertDateIsoDate = (params) => {
  let date;

  if (params?.value) {
    date = new Date(params.value);
  } else {
    date = new Date(params);
  }

  if (isNaN(date.getTime())) {
    return "N/A";
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const monthString = month < 10 ? `0${month}` : `${month}`;
  const dayString = day < 10 ? `0${day}` : `${day}`;

  return `${monthString}/${dayString}/${year}`;
};


function BillsFiltersUI({
  BillNO,
  Status,
  Pono,
  fromDate,
  toDate,
  setBillNO,
  setStatus,
  setPono,
  setFromDate,
  setToDate,
  reset,
}) {
  return (
    <Box className="pmt-title-box space-y-4">
      <Box className="typography-title">
        <Typography
          variant="h1"
          className="pmt-headings-h1 text-2xl sm:text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100"
        >
          Bills
        </Typography>
      </Box>

      {/* Filter Card */}
      <div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-3 sm:gap-4 rounded-[10px] p-4 sm:p-6 mb-2
                   bg-white/80 dark:bg-gray-900/80 backdrop-blur supports-[backdrop-filter]:bg-white/60 border border-gray-200 dark:border-gray-700 shadow-sm"
      >
      

        {/* Optional: Create Bill (kept commented as in original) */}
        {/**
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 grid gap-1  flex-justify-center items-center">
          <label className="capitalize text-[#000] mb-2 font-medium"></label>
          <button
            type="button"
            onClick={() => router.push(`/bills/create-bill`)}
            className="bg-[#00308F] gap-2 h-[45px] text-[#fff] font-semibold capitalize p-[5px] text-md text-sm rounded-[5px] px-[20px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff] float-right"
          >
            Create Bill
          </button>
        </div> 
        */}
      </div>
    </Box>
  );
}
